
const SearchFormFieldModel = Backbone.Model.extend({
	defaults: {
		collection:null,
		model:null,
		oldModel: null,
		view: null
	},
	setNull() {
		const model = this.get('model');

		if (model) {
			this.set('oldModel', model);
		}
		this.set('model', null, { initiator: 'controller' });
	},
	isGroupSearch() {
		const model = this.get('model');

		if (!model) {
			return false;
		}

		return model.get('touristsByRooms')?.length > 0;
	}
});

export default SearchFormFieldModel;